import type {
  DecisaoAprovacaoProposta,
  MeioEnvioProposta,
  OrigemProposta,
  StatusAssinaturaProposta,
  StatusProposta,
  TipoEventoNegociacao,
} from '../api';

/**
 * Utilitários de formatação do módulo Propostas Comerciais (US-COM-006).
 * Labels em pt-BR seguem o vocabulário da spec.
 */

export const STATUS_LABEL: Record<StatusProposta, string> = {
  em_elaboracao: 'Em Elaboração',
  em_revisao: 'Em Revisão',
  em_aprovacao: 'Em Aprovação',
  aguardando_complementacao: 'Aguardando Complementação',
  aprovada_internamente: 'Aprovada Internamente',
  enviada_ao_cliente: 'Enviada ao Cliente',
  em_negociacao: 'Em Negociação',
  aceita: 'Aceita',
  rejeitada: 'Rejeitada',
  cancelada: 'Cancelada',
  expirada: 'Expirada',
  convertida_em_contrato: 'Convertida em Contrato',
  substituida: 'Substituída',
};

export const ORIGEM_LABEL: Record<OrigemProposta, string> = {
  oportunidade: 'Oportunidade',
  renovacao: 'Renovação',
  upsell: 'Upsell',
  cross_sell: 'Cross Sell',
  solicitacao_direta: 'Solicitação direta',
  licitacao: 'Licitação',
  atualizacao_contrato: 'Atualização de contrato',
};

export const MEIO_ENVIO_LABEL: Record<MeioEnvioProposta, string> = {
  email: 'E-mail',
  portal: 'Portal',
  whatsapp: 'WhatsApp',
  entrega_fisica: 'Entrega física',
};

export const DECISAO_APROVACAO_LABEL: Record<DecisaoAprovacaoProposta, string> = {
  pendente: 'Pendente',
  aprovada: 'Aprovada',
  rejeitada: 'Rejeitada',
  devolvida: 'Devolvida',
};

export const TIPO_NEGOCIACAO_LABEL: Record<TipoEventoNegociacao, string> = {
  reuniao: 'Reunião',
  ligacao: 'Ligação',
  email: 'E-mail',
  contraproposta: 'Contraproposta',
  solicitacao_cliente: 'Solicitação do cliente',
  alteracao: 'Alteração',
};

export const STATUS_ASSINATURA_LABEL: Record<StatusAssinaturaProposta, string> = {
  requested: 'Solicitada',
  in_progress: 'Em andamento',
  completed: 'Concluída',
  failed: 'Falhou',
  cancelled: 'Cancelada',
};

function buildCurrencyFormatter(currency: 'BRL' | 'USD' | 'EUR') {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatCurrency(
  valor: string | number | null | undefined,
  currency: 'BRL' | 'USD' | 'EUR' = 'BRL',
): string {
  if (valor === null || valor === undefined || valor === '') return '—';
  const num = typeof valor === 'string' ? Number.parseFloat(valor) : valor;
  if (Number.isNaN(num)) return '—';
  return buildCurrencyFormatter(currency).format(num);
}

export function formatValidade(dataValidade: string | null | undefined): string {
  if (!dataValidade) return 'Sem validade';
  const d = new Date(dataValidade);
  return d.toLocaleDateString('pt-BR');
}
